/**
 * @desc 财务画像导航链接
 */
import styles from './nav.scss';
import React, { PureComponent } from 'react';
import { Link, hashHistory } from 'react-router';
import {PicturePageCode} from '../../../../constants/enum';
import {PicturePageText, PicturePageLink} from '../../../../constants/info';

export default class Nav extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { companyInfo } = hashHistory.getCurrentLocation().query;

        return (
            <ul id="financialPictureNav" className={styles.nav}>
                {
                    Object.values(PicturePageCode).map(d => {
                        return (
                            <li key={d}>
                                <Link to={`${PicturePageLink[d]}?companyInfo=${companyInfo}`} activeClassName={styles.active}>
                                    {PicturePageText[d]}
                                </Link>
                            </li>
                        );
                    })
                }
            </ul>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/common/nav/Nav.jsx